import { TmCart } from '@templates/tm-cart'
import { getNonCmsPageStaticProps, renderNonCmsPage } from '@utils/non-cms-page'
import { NotFoundPgPage, PgPageProps } from './[[...slug]]'
import { GetStaticPropsContext } from 'next'

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const props = await getNonCmsPageStaticProps(context)

  // Check if page not found
  if (props.notFound) {
    return props
  }

  return {
    ...props,
    revalidate: 10, // Added the revalidate option to trigger incremental static regeneration.
  }
}

const Cart = (props: PgPageProps | NotFoundPgPage) => {
  return renderNonCmsPage('Cart', { ...props, slug: 'cart' }, <TmCart />)
}

export default Cart
